/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {

  const unlockLineItems = () => {
    const el = document.querySelector("[data-line-items]");
    if (el && el.style.pointerEvents === "none") {
      el.style.pointerEvents = "auto";
      el.style.opacity = "1";
    }
  };

  sessionStorage.removeItem("TRANSFORMING_CART");

  document.addEventListener("DOMContentLoaded", unlockLineItems);
  document.addEventListener("theme:cart:change", unlockLineItems);
  document.addEventListener("theme:cart:reload", unlockLineItems);

  const observer = new MutationObserver(() => unlockLineItems());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  //Setting attributes to bettershiping & cashOn Delivery
  document.addEventListener("theme:partner:set", (event) => {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          cash_on_delivery: event.detail.partner.cash_on_delivery.toString(),
          personal_delivery: event.detail.partner.personal_delivery.toString(),
        }
      })
    })
    .then(response => response.json())
    .catch(error => console.error("Error al agregar atributo:", error));
  });
    
  
  const checkoutButtons = document.querySelectorAll('[name="checkout"]');

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      //console.log("Container ———————— ↓");
      //console.log(container);
      //console.log("Variant —————————— ↓");
      //console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", async function (event) {
    var cart = event.detail.cart;
    if (cart) {
      // validation
      checkCartTotalValid(cart);
      configureCheckoutButtons();
      configureGuestCheckout(cart);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    //console.log("theme:cart:init");
    //console.log(e);
  });

  // helpers
  const configureCheckoutButtons = () => {
    const lineItemsWrappers = document.querySelector("[data-line-items]")
    const qty = lineItemsWrappers.querySelectorAll('[data-quantity-selector]')
    if ( window.checkout.cartTotalIsValid && qty.length > 0) {
      checkoutButtons.forEach((button) => {
        button.disabled = false;
        button.addEventListener("click", handleCheckoutButtonClick);
      });
      lineItemsWrappers.style.pointerEvents = "auto";
      lineItemsWrappers.style.opacity = "1";
      return;
    }
  };

  /*
  const checkZipValid = () => {
    const errors = document.querySelectorAll("[data-zip-locator-cart-error]");
    let errorText = "";
    let errorTriggerLabel = "";
    let valid = false;

    if (window.zipLocator.zip && window.zipLocator.match) {
      valid = true;
      window.checkout.zipIsValid = valid;
      errors.forEach((error) => {
        error.classList.add("hide");
      });
      return;
    }

    if (!window.zipLocator.zip) {
      errorText = theme.strings.zipLocator.noZipError;
      errorTriggerLabel = theme.strings.zipLocator.noZipTriggerLabel;
    } else if (window.zipLocator.zip && !window.zipLocator.match) {
      errorText = theme.strings.zipLocator.invalidZipError;
      errorTriggerLabel = theme.strings.zipLocator.invalidZipTriggerLabel;
    }
    errors.forEach((error) => {
      const errorTextEl = error.querySelector("[data-zip-locator-cart-error-text]");
      const errorTriggerLabelEl = error.querySelector("[data-popup-zip-locator='zip-locator']");
      errorTextEl.textContent = errorText;
      errorTriggerLabelEl.textContent = errorTriggerLabel;
    });
    errors.forEach((error) => {
      error.classList.remove("hide");
    });
    window.checkout.zipIsValid = valid;
  };
*/
  const checkCartTotalValid = (cart) => {
    const errors = document.querySelectorAll("[data-invalid-cart-total-error]");
    let errorText = "";
    let valid = false;

    if (cart.total_price >= 15000) {
      valid = true;
      window.checkout.cartTotalIsValid = valid;
      errors.forEach((error) => {
        error.classList.add("hide");
      });
      checkoutButtons.forEach((button) => {
        button.disabled = false;
        button.addEventListener("click", handleCheckoutButtonClick);
      });
      return;
    }

    errorText = theme.strings.invalidCartTotal;
    errors.forEach((error) => {
      const errorTextEl = error.querySelector("[data-invalid-cart-total-error-text]");
      errorTextEl.textContent = errorText;
    });
    errors.forEach((error) => {
      error.classList.remove("hide");
    });
    checkoutButtons.forEach((button) => {
      button.disabled = true;
      button.addEventListener("click", handleCheckoutButtonClick);
    });
    window.checkout.cartTotalIsValid = valid;
  };

  const configureGuestCheckout = (cart) => {
    const guestCheckouts = document.querySelectorAll("[data-guest-checkout]");
    if (cart.items.length) guestCheckouts.forEach((elem) => elem.classList.remove("hide"));
    else guestCheckouts.forEach((elem) => elem.classList.add("hide"));
  };

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    //console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  /*-----------------------------------------------------------------------------*/

  const geocodeBaseURL = "https://maps.googleapis.com/maps/api/geocode/json?";
  const key = "AIzaSyC-to9oGgxoraWdZJPckgKVIsxSg9oj9m8";

  const LOCATION_STORAGE_KEY = "LOCATION_STORAGE_KEY";
  var location = {
    lat: null,
    long: null,
    city: null,
    state: null,
  };

  /* Fired when zip updates
  document.addEventListener("theme:locator:update", () => {
    checkZipValid();
    configureCheckoutButtons();
  });
  */

  async function handleCheckoutButtonClick(evt) {
    evt.preventDefault();
    getStoredZipLocationData();
    if (!window.zipLocator.lat && !window.zipLocator.long && !window.zipLocator.city && !window.zipLocator.state) {
      await locationLookup(window.zipLocator.zip);
      storeZipLocationData(location);
    }

    configureCheckoutAttributes();

    let matching = {
      delivery_guarantee_day: window.theme?.storefront_partner?.deliveryGuaranteeDay ?? null,
      name:window.theme?.storefront_partner?.displayName ?? null,
      storefront: window.theme?.storefront_partner?.displayName ?? null,
      usercode: window.theme?.storefront_partner?.betterwarePlusId ?? null,
    }


    const context = {
      curSite: localStorage.getItem("CURRENT_PARTNER_STORAGE_KEY") ?? null,
      zip: window.zipLocator.zip,
      lat: window.zipLocator.lat,
      long: window.zipLocator.long,
      matchedConsultant: matching,
      isPartner: window.customer.isPartner,
      betterwarePlusId: window.customer.betterwarePlusId,
    };

    // Construct URL with both location and distributor attributes
    const urlAttributes = `attributes[context]=${
      btoa(JSON.stringify(context))
    }&attributes[Latitude]=${
      window.zipLocator.lat
    }&attributes[Longitude]=${
      window.zipLocator.long
    }&attributes[ReferralID]=${
      window.zipLocator.attributes?.referralId
    }&attributes[DistributorCode]=${
      window.zipLocator.attributes?.distributorId
    }&attributes[DistributorFullName]=${
      window.zipLocator.attributes?.distributorName
    }&attributes[DistributorStorefront]=${
      window.zipLocator.attributes?.distributorStorefront
    }&attributes[BetterShipping]=${
      window.zipLocator.attributes?.betterShipping
    }&attributes[DeliveryGuaranteeDay]=${
      window.zipLocator.attributes?.deliveryGuaranteeDay
    }`;
    const checkoutUrl = `/checkout?${urlAttributes}`;

    // Log the constructed URL to the console
    //console.log("Constructed Checkout URL:", checkoutUrl);

    // Redirect to the checkout URL
    window.location.href = checkoutUrl;
  }

  // helpers
  function configureCheckoutAttributes() {
    let attributes = null;

    // Fetch distributor attributes from local storage
    const storedReferralId = window.zipLocator.referral?.usercode;
    const storedMatchedDistributorName = window.zipLocator.match?.name;
    const storedMatchedDistributorUsercode = window.zipLocator.match?.usercode;
    const storedMatchedDistributorDeliveryGuaranteeDay = window.zipLocator.match?.delivery_guarantee_day;

    let referralId = storedReferralId || "NONE";
    let distributorId = storedMatchedDistributorUsercode;
    let distributorName = storedMatchedDistributorName;
    let deliveryGuaranteeDay = storedMatchedDistributorDeliveryGuaranteeDay || "NONE";
    let distributorStorefront = theme.storefront_partner ? true : false;
    let betterShipping = false;

    if (!window.zipLocator.match?.coverage) {
      betterShipping = true;
    }

    attributes = { referralId, distributorId, distributorName, distributorStorefront, betterShipping, deliveryGuaranteeDay };
    window.zipLocator.attributes = attributes;
  }

  function getStoredZipLocationData() {
    const storedLocation = localStorage.getItem(LOCATION_STORAGE_KEY);
    const parsedLocation = JSON.parse(storedLocation);

    window.zipLocator.lat = parsedLocation?.lat;
    window.zipLocator.long = parsedLocation?.long;
    window.zipLocator.city = parsedLocation?.city;
    window.zipLocator.state = parsedLocation?.state;
  }

  function storeZipLocationData(location) {
    const locationStr = JSON.stringify(location);

    localStorage.setItem(LOCATION_STORAGE_KEY, locationStr);
    window.zipLocator.lat = location?.lat;
    window.zipLocator.long = location?.long;
    window.zipLocator.city = location?.city;
    window.zipLocator.state = location?.state;
  }

  async function locationLookup(zipCode) {
    const url = `${geocodeBaseURL}address=${zipCode}&components=country:MX&sensor=true&key=${key}`;

    await fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        var results = response.results;
        if (results.length) {
          location.lat = results[0].geometry?.location?.lat;
          location.long = results[0].geometry?.location?.lng;

          var addressComponents = results[0].address_components;
          addressComponents.forEach((addressComponent) => {
            if (!location.city && addressComponent.types.includes("locality")) {
              location.city = addressComponent.long_name;
            }
            if (!location.state && addressComponent.types.includes("administrative_area_level_1")) {
              location.state = addressComponent.short_name;
            }
          });
        }
      })
      .catch((e) => {
        // console.error(e);
      });
  }

  // password visibility toggle
  const passwordVisibilityToggles = document.querySelectorAll("[data-password-visibility-toggle]");

  passwordVisibilityToggles.forEach((toggle) => {
    const parent = toggle.closest("[data-password-visibility-wrap]");
    const passwordInput = parent.querySelector("input");

    toggle.addEventListener("click", () => {
      toggle.classList.toggle("is-visible");
      if (passwordInput.type == "password") {
        passwordInput.type = "text";
      } else passwordInput.type = "password";
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (!theme.storefront_partner) {
      let js = document.createElement("script");
      js.type = "text/javascript";
      js.async = 1;
      js.src = "https://go.botmaker.com/rest/webchat/p/M3ZOHJBAP1/init.js";
      document.body.appendChild(js);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
